// @flow
import { addMinutes, isAfter } from "date-fns"
import type { Dispatch } from "redux"

import { getSessionCreated, getSessionValid } from "./reducer"
import type {
  SetLoading,
  SetSubmitting,
  SetSubmittingWithTimestamp,
  SetActiveStep,
  SetFlightsChecked,
  SetBillingDetails,
  ToggleBillingDetails,
  InitStates,
  InitStatesPayload,
  LoadSuccessStatesPayload,
  LoadSuccessStates,
  UpdateSuccessStatesPayload,
  UpdateSuccessStates,
  SaveSuccessStatesPayload,
  SaveSuccessStates,
  SetFlightsCheckForced,
  SetPreBookingStatePayload,
  SetSessionInvalid,
  SetSessionValid,
  RemoveOriginalPromocode,
  SetPreBookingState,
} from "booking/services/states/types"

type GetState = () => {
  reservation: {
    states: {
      session: {
        created: number,
        valid: boolean,
      },
    },
  },
}

// Actions
// ===
export const setLoading = (loading: boolean): SetLoading => ({
  type: "SET_LOADING",
  payload: loading,
})
export const setSubmitting = (submitting: boolean): SetSubmitting => ({
  type: "SET_SUBMITTING",
  payload: submitting,
})
export const setSubmittingWithTimestamp = (submitting: boolean): SetSubmittingWithTimestamp => ({
  type: "SET_SUBMITTING_WITH_TIMESTAMP",
  payload: submitting,
})
export const setActiveStep = (activeStep: number): SetActiveStep => ({
  type: "SET_ACTIVE_STEP",
  payload: activeStep,
})

export const setReservationVariant = (variant: string) => ({
  type: "SET_RESERVATION_VARIANT",
  payload: variant,
})

export const setFlightsChecked = (flightsChecked: boolean): SetFlightsChecked => ({
  type: "SET_FLIGHTS_CHECKED",
  payload: flightsChecked,
})
export const setBillingDetails = (billingDetails: boolean): SetBillingDetails => ({
  type: "SET_BILLING_DETAILS",
  payload: billingDetails,
})
export const toggleBillingDetails = (): ToggleBillingDetails => ({
  type: "TOGGLE_BILLING_DETAILS",
})

export const initStates = (payload: InitStatesPayload): InitStates => ({
  type: "INIT_STATES",
  payload,
})

export const loadSuccessStates = (payload: LoadSuccessStatesPayload): LoadSuccessStates => ({
  type: "LOAD_SUCCESS_STATES",
  payload,
})

export const updateSuccessStates = (payload: UpdateSuccessStatesPayload): UpdateSuccessStates => ({
  type: "UPDATE_SUCCESS_STATES",
  payload,
})

export const saveSuccessStates = (payload: SaveSuccessStatesPayload): SaveSuccessStates => ({
  type: "SAVE_SUCCESS_STATES",
  payload,
})

export const setFlightsCheckForced = (): SetFlightsCheckForced => ({
  type: "SET_FLIGHTS_CHECK_FORCED",
})

export const setSessionInvalid = (): SetSessionInvalid => ({
  type: "SET_SESSION_INVALID",
})

export const setSessionValid = (): SetSessionValid => ({
  type: "SET_SESSION_VALID",
})

export const removeOriginalPromocode = (): RemoveOriginalPromocode => ({
  type: "REMOVE_ORIGINAL_PROMOCODE",
})

export const setPreBookingState = (payload: SetPreBookingStatePayload): SetPreBookingState => ({
  type: "SET_PREBOOKING_STATE",
  payload,
})

// Action creators
// ===

// FIXME: Change based on logs after first release
const SESSION_EXPIRATION_LIMIT_MINUTES = 30

export const checkSessionValidity = () => (dispatch: Dispatch<*>, getState: GetState) => {
  const state = getState()
  const sessionCreated = getSessionCreated(state)
  const sessionValid = getSessionValid(state)
  const expiration = addMinutes(new Date(sessionCreated), SESSION_EXPIRATION_LIMIT_MINUTES)

  if (sessionValid && isAfter(new Date(), expiration)) {
    dispatch(setSessionInvalid())
  }
}
